import { render, staticRenderFns } from "./DeliveryConfigurationByUnitsViewer.vue?vue&type=template&id=cbfb2406&"
import script from "./DeliveryConfigurationByUnitsViewer.vue?vue&type=script&lang=js&"
export * from "./DeliveryConfigurationByUnitsViewer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports